/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Code_SubmitInputs */



/**
* | output |
* | --- |
* | "Sign in with the code" |
*
* @param {Login_Code_SubmitInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const login_code_submit = /** @type {((inputs?: Login_Code_SubmitInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Code_SubmitInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Meld je aan met de code")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Se connecter avec le code")
	return /** @type {LocalizedString} */ ("Sign in with the code")
});